<template>
  <div class="d-flex">
    <button
      id="vips-logo-slider-button-prev"
      class="swiper-button swiper-button--prev mr-6"
    >
      <img alt src="/dist/assets/front_white/img/arrow-left-gray-filled.svg" />
    </button>

    <div class="vips-slider flex-grow-1">
      <div
        ref="swiper"
        v-swiper:vipsSlider="swiperOptions"
        class="swiper links-cnt"
        @slideChangeTransitionEnd="setTranslate"
      >
        <div class="vips-slider__wrapper swiper-wrapper vips-block">
          <a
            v-for="vip in vips"
            :key="vip.id"
            :href="`/manufacturer/${vip.name_alias}/${vip.id}/`"
            :title="vip.name_short"
            target="_blank"
            class="vips-block__item swiper-slide"
            @click="$logActionEvent('vip logo click', { itemId: vip.id })"
          >
            <img
              :src="vip.logo.svg"
              :alt="vip.name_alias"
              class="vips-block__image"
            >
          </a>
        </div>
      </div>
    </div>

    <button
      id="vips-logo-slider-button-next"
      class="swiper-button swiper-button--next ml-6"
    >
      <img alt src="/dist/assets/front_white/img/arrow-right-gray-filled.svg" />
    </button>
  </div>
</template>

<script>
import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

let prevIndex

export default {
  name: 'LogoSwiper',
  directives: {
    swiper: directive,
  },
  props: {
    vips: Array
  },
  data() {
    return {
      swiperOptions: {
        autoplay: true,
        slidesPerView: 8,
        spaceBetween: 12,
        loop: true,
        freeMode: true,
        navigation: {
          nextEl: '#vips-logo-slider-button-next',
          prevEl: '#vips-logo-slider-button-prev',
        },
        breakpoints: {
          1279:{
            slidesPerView: 8,
          }, 
          768: {
            slidesPerView: 6,
          },
          575: {
            slidesPerView: 4,
          },
          319: {
            slidesPerView: 3,
          },
        },
      }
    }
  },
  mounted() {
    this.logViewVip(
      this.vips
        .slice(0, this.swiperOptions.slidesPerView)
        .map(vip => vip.id)
    )
    this.$logActionEvent('vip slider showed')
  },
  methods: {
    setTranslate() {
      const { realIndex, $el } = this.vipsSlider

      if (
        window.scrollY
        > $el[0].offsetTop
      ) return

      if (prevIndex === realIndex) return
      if (realIndex < prevIndex || prevIndex === 0) {
        this.logViewVip([
          this.vips.slice(
            realIndex - 4,
            realIndex - 3
          )[0].id
        ])
      } else {
        this.logViewVip(
          [this.vips[(realIndex + 3) % this.vips.length].id]
        )
      }

      prevIndex = realIndex
    },
    logViewVip(manufacturers) {
      this.$logActionEvent(
        'vip logo view',
        { manufacturers }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.vips-slider {
  position: relative;

  .vips-slider__wrapper {
    width: 0;
  }

  .swiper {
    overflow: hidden;

    .swiper-wrapper {
      margin: initial;
      position: relative;
    }
  }

  .swiper-slide {
    width: auto;
  }

  .swiper-button {
    position: relative;
    top: 15px;
    border: 0;
    margin: 0;
    padding: 0;
    background-color: inherit;
    cursor: pointer;
    transition: opacity .1s;
    z-index: 1;

    &:hover {
      opacity: .69;
    }

    &.swiper-button--prev {
      left: 0;
    }

    &.swiper-button--next {
      right: 0;
    }
  }
}

.vips-block {

  .vips-block__item {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100px;

    &:hover {
      opacity: .77;
    }
  }

  .vips-block__image {
    height: 50px;
    max-width: 100%;
    object-fit: contain;
  }
}
</style>
